import { SvgIcon, type SvgIconProps } from './svgIcon'

export const SmileyIcon = ({
  width = 24,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM7.42578 14.2471C7.49531 14.4292 7.57173 14.6011 7.66211 14.7754C8.44625 16.352 10.2271 17.3973 12.001 17.375C13.7746 17.4013 15.5604 16.3556 16.3398 14.7744C16.4298 14.5996 16.5063 14.4278 16.5752 14.2451C16.1919 14.0817 15.8081 13.9183 15.4248 13.7549C15.3585 13.889 15.2885 14.0128 15.21 14.1367C14.522 15.2427 13.278 15.8827 12.0029 15.875C10.7276 15.8804 9.48233 15.2387 8.79004 14.1338C8.71121 14.0102 8.64102 13.8867 8.57422 13.7529C8.19155 13.9178 7.80845 14.0822 7.42578 14.2471ZM9.25 7.5C8.42157 7.5 7.75 8.29582 7.75 9.40039C7.75016 10.5047 8.42167 11.25 9.25 11.25C10.0783 11.25 10.7498 10.5047 10.75 9.40039C10.75 8.29582 10.0784 7.5 9.25 7.5ZM14.75 7.5C13.9216 7.5 13.25 8.29582 13.25 9.40039C13.2502 10.5047 13.9217 11.25 14.75 11.25C15.5783 11.25 16.2498 10.5047 16.25 9.40039C16.25 8.29582 15.5784 7.5 14.75 7.5Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)
